import {json} from '../core/data-source/json.mapper';

export class CustomerRecord {
    @json()
    id: number;

    @json()
    name: string;

    @json()
    contactName: string;

    @json()
    contactNumber: string;
}
